module.exports = __webpack_public_path__ + "static/media/keyRight.aca2b5ff.png";